









































































































































































import { mapGetters, mapState } from 'vuex'
import { format, getRelativeDate } from '~/utils/date'
import { USER_NS } from '~/store/modules/shared/user/state'
import {
  faEllipsisV,
  faTimes,
  faTimesCircle,
  faTrash
} from '@fortawesome/free-solid-svg-icons'
import CContextMenu from '~/components/shared/configurable/CContextMenu.vue'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import CMiniMessageThreadContents from '~/components/shared/configurable/message/CMiniMessageThreadContents.vue'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { TRADES_NS } from '~/store/modules/shared/trades/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'
import { ciArrowAltLeft } from '~/icons/source/solid/arrow-alt-left'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: {
    CAvatar,
    CConfirmationModal,
    CMiniMessageThreadContents,
    CContextMenu
  },
  props: {
    messageThread: { type: Object, required: true, default: null },
    mailbox: { type: String, required: true },
    hideForClsfd: { type: Boolean, required: false, default: false },
    ownedDealers: {
      type: Array,
      default() {
        return []
      }
    },
    activeStatus: { type: Boolean, required: false, default: false },
    threadOpened: { type: Boolean, required: false, default: false },
    inTrades: { type: Boolean, required: false, default: false },
    inModal: { type: Boolean, required: false, default: false },
    showBack: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      isActive: false,
      hasPending: false,
      deleteModalVisible: false
    }
  },
  computed: {
    ...mapGetters(USER_NS, {
      isAdmin: 'isAdmin',
      isGuest: 'isGuest',
      isDealer: 'isOfTypeDealer',
      isSingle: 'isSingle'
    }),
    ...mapState(TRADES_NS, {
      detailsClassifiedId: 'detailsClassifiedId'
    }),
    ...mapGetters(USER_AGENT_NS, {
      isMobile: 'isMobile'
    }),
    icons() {
      return {
        ellipsis: faEllipsisV,
        trash: faTrash,
        link: ciExternalLink,
        timesCircle: faTimesCircle,
        close: faTimes,
        arrowLeft: ciArrowAltLeft
      }
    },
    avatarToDisplay() {
      if (this.inTrades && this.messageThread.classified?.cover) {
        return this.messageThread.classified.cover
      }
      return this.messageThread.participant.display_photo
    },
    fullThreadLink() {
      const link = this.$router.resolve({
        name: '__account_messages'
      }).href

      return `${link}?thread=${this.messageThread.id}`
    },
    dateRelative() {
      return getRelativeDate(
        this.messageThread.last_message_ts,
        this.$i18n.locale
      )
    },
    detailedDate() {
      return format(this.messageThread.last_message_ts)
    },
    participantDeleted() {
      return this.messageThread.participant.is_deleted
    },
    participantNameToDisplay() {
      if (this.participantDeleted) {
        return '[' + this.$t('deleted::msg_deleted') + ']'
      }

      return this.messageThread.participant.display_name
    },
    tradesThread() {
      return this.messageThread.topic === 'trades'
    },
    topicTitle() {
      switch (this.messageThread.topic) {
        case 'classified_offer':
          return this.$t('offer::prosfora')
        case 'wanted_parts':
          return this.$t('wanted_parts')
        case 'marketplace':
          return this.messageThread.marketplace_order
            ? this.$t('for_order_id', {
                order: this.messageThread.marketplace_order.id
              })
            : this.$t('for_store')
        default:
          return ''
      }
    },
    routeBackToTrades() {
      if (this.inTrades) {
        const { query, params } = this.$router.currentRoute
        const from = query.from
        const pg = query.pg || null
        const classifiedId = params?.cid

        const hash = this.detailsClassifiedId
          ? `#${this.detailsClassifiedId}`
          : undefined

        if (classifiedId) {
          if (from === 'home') {
            return {
              name: '__trades_page',
              params: { cid: classifiedId },
              hash
            }
          }
          return {
            name: '__trades_matches',
            params: { cid: classifiedId },
            query: { pg },
            hash
          }
        }
      }
      return null
    }
  },
  watch: {
    activeStatus() {
      if (!this.hasPending) {
        this.isActive = this.activeStatus
      }
    }
  },
  updated() {
    this.$emit('updated')
  },
  created() {
    if (this.threadOpened) {
      this.isActive = true
      setTimeout(() => {
        this.$emit('updated')
      }, 300)
    }
  },
  methods: {
    threadClicked(e) {
      if (this.inTrades) {
        return
      }
      if (!this.hasPending) {
        if (!this.isActive) {
          if (e.ctrlKey || e.metaKey) {
            this.$emit('threadActive')
          } else {
            this.$emit('threadActiveOnly')
          }
        } else {
          this.$emit('threadDeactivated')
        }
      }
    },
    stopPropagation(e) {
      return e.stopPropagation()
    },
    CloseThread() {
      this.isActive = false
    },
    messageRead() {},
    deleteThreadClicked(e) {
      e.stopPropagation()
      this.deleteModalVisible = true
    },
    emitThreadDeletion() {
      this.$emit('delete-thread')
    },
    threadJustEmpty() {
      this.$emit('thread-just-empty')

      if (this.inTrades) {
        this.$refs.backtrades.$el.click()
      }
    }
  }
})
